import {Helmet} from "react-helmet";
import React from "react";
import logo from "../../../../assets/images/logo.png";
import './CancellationPolicy.scss';


const CancellationPolicy = () => {

  return (
    <>
      <Helmet>
        <title>Política de Pagamentos, Reembolsos e Cancelamentos</title>
      </Helmet>
      <div className="CancellationPolicy">
        <div className="navbar">
          <img src={logo} alt="Logo" style={{ height: '100%' }} />
        </div>

        <div className="content">
          <h1 className={"header"}>Política de Pagamentos, Reembolsos e Cancelamentos</h1>
          <>
            <p style={{ textAlign: "justify" }}>
              A presente política regula os pagamentos e direitos do consumidor na compra
              de ingressos para eventos, em conformidade com o Código de Defesa do
              Consumidor (Lei 8.078/90), no que tange a eventuais pedidos de desistência,
              reembolso, cancelamentos e demais situações.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>PAGAMENTOS</strong>
            </p>
            <ol className="awlist1" style={{ margin: "0pt", paddingLeft: "0pt" }}>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "108%",
                  fontSize: "10pt"
                }}
              >
      <span
        style={{
          width: "8.56pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                <span style={{ lineHeight: "108%", fontSize: "11pt" }}>A </span>
                <strong>
                  <span style={{ lineHeight: "108%", fontSize: "11pt" }}>CLAP </span>
                </strong>
                <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
        aceita os principais meios de pagamento eletrônico: cartão de crédito,
        débito, PIX e boleto;
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "108%",
                  fontSize: "10pt"
                }}
              >
      <span
        style={{
          width: "5.78pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;{" "}
      </span>
                <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
        Todos os pagamentos são processados em ambiente seguro e criptografado;
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "108%",
                  fontSize: "10pt"
                }}
              >
      <span
        style={{
          width: "3pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;{" "}
      </span>
                <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
        O processamento é intermediado por parceiros homologados PCI-DSS.
      </span>
              </li>
            </ol>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>CONFIRMAÇÃO E EMISSÃO DE INGRESSOS</strong>
            </p>
            <ol className="awlist2" style={{ margin: "0pt", paddingLeft: "0pt" }}>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "108%",
                  fontSize: "10pt"
                }}
              >
      <span
        style={{
          width: "8.56pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
        A emissão do ingresso ocorre após a confirmação do pagamento;
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "108%",
                  fontSize: "10pt"
                }}
              >
      <span
        style={{
          width: "5.78pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;{" "}
      </span>
                <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
        Você receberá um e-mail com o ingresso e orientações de acesso ao
        evento.
      </span>
              </li>
            </ol>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              <strong>DESISTÊNCIA, CANCELAMENTO E REEMBOLSO</strong>
            </p>
            <p style={{ textAlign: "justify" }}>
              Qualquer manifestação de desistência/cancelamento do comprador, deve ocorrer
              através do contato direto do comprador com o organizador, segundo política
              de cancelamento do próprio organizador. O Art. 49 da Lei 8.078/09 do Código
              de Defesa do Consumidor garante um prazo legal de 7 dias após a compra para
              solicitar o estorno de pagamento. A CLAP não será responsável por qualquer
              ressarcimento cujos valores do evento
              <br />
              foram transferidos ao organizador em sua totalidade.
            </p>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              Em caso de alteração, adiamento ou cancelamento do evento adquirido, o
              comprador deve ser informado pelo organizador, assim como as orientações
              sobre procedimentos de alteração, cancelamento e reembolso.
            </p>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              Será cumprida a política de cancelamento específica do evento elaborado pelo
              organizador, quando houver, desde que não fira a política de cancelamento da
              CLAP.
            </p>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              O organizador é responsável por encaminhar solicitação de reembolso para
              CLAP por e-mail ou pelo chat de suporte. O mesmo, é responsável pelo
              fornecimento das informações necessárias para reembolso dos valores
              referentes a desistência ou cancelamento.
            </p>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              <strong>INFORMAÇÕES NECESSÁRIAS PARA O REEMBOLSO</strong>
            </p>
            <p style={{ textAlign: "justify" }}>
              No caso de reembolso, o organizador deverá providenciar as seguintes
              informações a depender da forma de pagamento:
            </p>
            <ol className="awlist3" style={{ margin: "0pt", paddingLeft: "0pt" }}>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "25.62pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>{" "}
                Cartão de crédito/débito: o organizador deve informar o nome do evento,
                número da inscrição e o valor a ser estornado.
              </li>
              <li
                style={{ marginLeft: "54pt", textIndent: "-36pt", textAlign: "justify" }}
              >
      <span
        style={{
          width: "22.56pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Pagamentos com boleto/transferência online/PIX: o organizador deve
                encaminhar o&nbsp;
                <a
                  href="/formulario-reembolso"
                  style={{ textDecoration: "none" }}
                >
                  <u>
                    <span style={{ color: "#467886" }}>formulário de solicitação</span>
                  </u>
                </a>
                &nbsp;de reembolso preenchido.
              </li>
            </ol>
            <p style={{ textAlign: "justify" }}>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ textAlign: "justify" }}>
              <strong>PROCESSO DE REEMBOLSO CLAP</strong>
            </p>
            <ol className="awlist4" style={{ margin: "0pt", paddingLeft: "0pt" }}>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "25.62pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Cartão de crédito: o reembolso do valor será solicitado à operadora do
                cartão, que disponibilizará o crédito de acordo com os prazos de
                fechamento da fatura e/ou banco emissor.
              </li>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "22.56pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Cartão de débito: o reembolso do valor será solicitado à operadora do
                cartão utilizado na compra, que creditará o valor em conta bancária
                vinculada ao cartão.
              </li>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "19.51pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Boleto, transferência online e PIX: o reembolso será realizado na conta
                bancária especificada no formulário de solicitação de reembolso ou via PIX
                se houver uma chave vinculada a conta informada, e será concluído em até 3
                dias úteis a partir do lançamento no sistema, na condição de que todos os
                dados estejam corretos.
              </li>
              <li
                style={{ marginLeft: "54pt", textIndent: "-36pt", textAlign: "justify" }}
              >
      <span
        style={{
          width: "20.12pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                O comprovante das operações ficará disponível no sistema após efetivação
                do processo.
              </li>
            </ol>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              <strong>TAXAS E PRAZOS</strong>
            </p>
            <ol className="awlist5" style={{ margin: "0pt", paddingLeft: "0pt" }}>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "25.62pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                A taxa mínima (R$5,00) ficará retida no extrato do evento nos casos de
                reembolso de pagamentos feitos com boleto/transferência online/PIX devido
                aos custos da operação bancária.
              </li>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "22.56pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Transferências para o Banco do Brasil não acarretarão custos. Em
                transferências para outros bancos será cobrada tarifa de DOC ou TED.
                Transferência por PIX será cobrada tarifa de 1% do valor transferido. O
                lançamento ficará disponível para verificação no extrato do evento.
              </li>
              <li
                style={{
                  marginLeft: "54pt",
                  marginBottom: "0pt",
                  textIndent: "-36pt",
                  textAlign: "justify"
                }}
              >
      <span
        style={{
          width: "19.51pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Nos casos de compra parcelada com juros: a taxa de juros será retida para
                solicitações feitas 30 dias após a compra.
              </li>
              <li
                style={{ marginLeft: "54pt", textIndent: "-36pt", textAlign: "justify" }}
              >
      <span
        style={{
          width: "20.12pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
                Após 1 ano da compra realizada, não há possibilidade de estorno por parte
                da operadora de cartão.
              </li>
            </ol>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              <strong>REEMBOLSO PARCIAL</strong>
            </p>
            <p style={{ textAlign: "justify" }}>
              Não é possível estorno parcial para pagamentos feitos por cartão de débito.
              Para as demais formas de pagamento, segue o processo de reembolso padrão.
            </p>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              <strong>CONTESTAÇÃO DE VENDA</strong>
            </p>
            <p style={{ textAlign: "justify" }}>
              A contestação de venda, também conhecida como chargeback, acontece quando o
              inscrito entra em contato com a operadora do seu cartão de crédito e cancela
              a compra da inscrição do evento realizada com este cartão.
            </p>
            <p style={{ textAlign: "justify" }}>
              Isso pode acontecer tanto em transações feitas em lojas físicas quanto em
              e-commerces, motivado por três razões:
            </p>
            <p style={{ textAlign: "justify" }}>
              (i) Fraude: nesse caso, a pessoa que é portadora do cartão não reconhece a
              compra efetuada;
            </p>
            <p style={{ textAlign: "justify" }}>
              (ii) Erro de processamento: quando a pessoa portadora do cartão identifica
              algum erro na cobrança como, por exemplo, a duplicidade de pagamentos, valor
              da transação ou número de cartão incorretos, transação processada sem
              autorização ou negada etc;
            </p>
            <p style={{ textAlign: "justify" }}>
              (iii) Desacordo comercial: ocorre quando a pessoa portadora do cartão
              reconhece a compra, mas alega que os termos da venda não foram cumpridos.
              Exemplos: mercadoria não entregue ou com defeito; não-prestação do serviço
              acordado; cancelamento de transação recorrente que não foi efetuado; crédito
              não processado etc.
            </p>
            <p style={{ textAlign: "justify" }}>&nbsp;</p>
            <p style={{ textAlign: "justify" }}>
              Quando receber uma notificação de chargeback a <strong>CLAP </strong>lançará
              um estorno provisório do valor contestado no extrato do evento, caso haja
              saldo. Caso não haja saldo suficiente no extrato do evento, o organizador,
              desde já, fica ciente que, a <strong>CLAP </strong>se reserva o direito de
              cobrar o valor diretamente do organizador.
            </p>
            <p>&nbsp;</p>
            <p>Essa política entra em vigor em 13/04/2025</p>
          </>

        </div>
      </div>
    </>
  );
}

export default CancellationPolicy;